/** PURE_IMPORTS_START .._.._Observable,.._.._operator_startWith PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { startWith } from '../../operator/startWith';
Observable.prototype.startWith = startWith;
//# sourceMappingURL=startWith.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/startWith.js
// module id = 718
// module chunks = 0